import React from 'react';
import { ColorSwatch as AriaColorSwatch, type ColorSwatchProps, composeRenderProps } from 'react-aria-components';
import { cn } from '../utils';

export function ColorSwatch(props: ColorSwatchProps) {
	return (
		<AriaColorSwatch
			{...props}
			className={composeRenderProps(props.className, (className) => cn('h-8 w-8 rounded-xs border border-black/10', className))}
			style={({ color }) => ({
				background: `linear-gradient(${color}, ${color}),
          repeating-conic-gradient(#CCC 0% 25%, white 0% 50%) 50% / 16px 16px`
			})}
		/>
	);
}
